export default __webpack_public_path__ + "static/media/commerce.457bea4f.png";